import React from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { Plus, Settings } from 'lucide-react';
import { SocietiesListPage as SharedSocietiesListPage } from '@/features/societies/components/SocietiesListPage';
import { useAuthStore } from '@/Stores/auth-v2-store';
import { useCurrentUserWording } from '../../../hooks/useVendorWording';

/**
 * Page de liste des sociétés (outil-pro)
 * Wrapper autour du composant partagé SocietiesListPage
 */
export const SocietiesListPage: React.FC = () => {
  const navigate = useNavigate();
  const { hasPermission, currentUser } = useAuthStore();
  const wording = useCurrentUserWording();

  const canCreate = hasPermission('society.create') && currentUser?.type === 'INTERNAL';
  const canManagePresets = hasPermission('society.manage_presets');

  return (
    <SharedSocietiesListPage
      embedded
      title="Liste des sociétés"
      wordingColumnLabel={wording.plural}
      onRowClick={currentUser?.type !== 'EXTERNAL' ? (society) => navigate(`/societies/${society.uuid}/dashboard`) : undefined}
      headerActions={
        <div className="tw-flex tw-items-center tw-gap-3">
          {canManagePresets && (
            <Link
              to="/societies/presets"
              className="tw-flex tw-items-center tw-gap-2 tw-px-4 tw-py-2 tw-bg-white tw-text-gray-700 tw-border tw-border-gray-300 tw-rounded-lg hover:tw-bg-gray-50 hover:tw-text-affinicar-primary tw-transition tw-font-medium tw-no-underline"
            >
              <Settings className="tw-w-4 tw-h-4" />
              Presets
            </Link>
          )}
          {canCreate && (
            <button
              onClick={() => navigate('/societies/create')}
              data-testid="btn-create-society"
              className="tw-flex tw-items-center tw-gap-2 tw-px-4 tw-py-2 tw-bg-affinicar-primary tw-text-white tw-rounded-lg hover:tw-bg-affinicar-secondary tw-transition-colors"
            >
              <Plus className="tw-w-5 tw-h-5" />
              Nouvelle société
            </button>
          )}
        </div>
      }
    />
  );
};
